import { render } from "storyblok-rich-text-react-renderer"
import SbEditable from "@mkt/ui/components/common/SbEditable"
import { Accordion } from "iq-blueberry"
import { mapIcons } from "@mkt/cp/src/styles/Functions.js"
import { isDesktop } from "@mkt/utils/getDevice"
import * as S from "./styles.js"

const Benefits = ({ blok }) => {
  const openItem = isDesktop()

  return (
    <div css={S.benefits}>
      <SbEditable content={blok}>
        <Accordion>
          <Accordion.Item titleChild={blok?.title} open={!!openItem}>
            {blok?.body.map((childBlok) => (
              <SbEditable content={childBlok} key={childBlok._uid}>
                <div css={S.benefits}>
                  <div css={S.item}>
                    <div css={S.label}>
                      {mapIcons[childBlok.icon]}
                      <span>{childBlok.title}</span>
                    </div>
                    <div css={S.value}>{render(childBlok.desc)}</div>
                  </div>
                </div>
              </SbEditable>
            ))}
          </Accordion.Item>
        </Accordion>
      </SbEditable>
    </div>
  )
}
export default Benefits
